import { revitApplications } from "@/mocks/serviceRevitData";

export default function RevitApplications() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="reveal text-center mb-10 md:mb-14">
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
            Aplicaciones
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            ¿Para qué proyectos utilizamos BIM?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            El modelado BIM se adapta a una amplia variedad de proyectos de ingeniería y edificación.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {revitApplications.map((app, i) => (
            <div
              key={app.title}
              className="reveal flex items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-5 hover:border-[#0087a4]/40 transition-colors"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="w-11 h-11 rounded-lg bg-[#0087a4]/10 text-[#0087a4] flex items-center justify-center shrink-0">
                <i className={`${app.icon} text-xl`} />
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug">
                {app.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}